import { useQuery } from '@tanstack/react-query';
import type { ContactStatementKind, ContactStatementResponse } from '@accounting/shared';
import { api } from '../lib/api';

export function useContactStatement(
  companyId: string | null,
  kind: ContactStatementKind,
  contactId: string,
  from: string,
  to: string,
) {
  return useQuery({
    queryKey: ['contact-statement', companyId ?? 'none', kind, contactId, from, to],
    enabled: companyId !== null && !!contactId,
    queryFn: () => {
      const params: Record<string, string> = {};
      if (from) params.from = from;
      if (to) params.to = to;
      return api.get<ContactStatementResponse>(`/companies/${companyId}/statements/${kind}/${contactId}`, params);
    },
  });
}
